import { supabase } from '@/lib/supabase'

export type AccountAccessState = {
  accountId: string | null
  effectivePlanId: string | null
  overrideActive: boolean
  overridePlanId: string | null
  originalPlanId: string | null
  originalInterval: string | null
  reason: string | null
  source: string | null
  noticePending: boolean
  noticeDismissedAt: string | null
  stripeSubscriptionId: string | null
  subscriptionStatus: string | null
  subscriptionCurrentPeriodStart: string | null
  subscriptionCurrentPeriodEnd: string | null
  subscriptionIsTrial: boolean | null
  subscriptionTrialEndsAt: string | null
  subscriptionPlanId: string | null
}

function mapAccessState(row: any): AccountAccessState {
  return {
    accountId: row?.account_id ?? null,
    effectivePlanId: row?.effective_plan_id ?? null,
    overrideActive: !!row?.override_active,
    overridePlanId: row?.override_plan_id ?? null,
    originalPlanId: row?.original_plan_id ?? null,
    originalInterval: row?.original_interval ?? null,
    reason: row?.reason ?? null,
    source: row?.source ?? null,
    noticePending: !!row?.notice_pending,
    noticeDismissedAt: row?.notice_dismissed_at ?? null,
    stripeSubscriptionId: row?.stripe_subscription_id ?? null,
    subscriptionStatus: row?.subscription_status ?? null,
    subscriptionCurrentPeriodStart: row?.subscription_current_period_start ?? null,
    subscriptionCurrentPeriodEnd: row?.subscription_current_period_end ?? null,
    subscriptionIsTrial: row?.subscription_is_trial == null ? null : !!row?.subscription_is_trial,
    subscriptionTrialEndsAt: row?.subscription_trial_ends_at ?? null,
    subscriptionPlanId: row?.subscription_plan_id ?? null,
  }
}

export async function getAccountAccessState(): Promise<AccountAccessState | null> {
  const { data, error } = await supabase.rpc('get_account_access_state')
  if (error) throw error
  const row = Array.isArray(data) ? data[0] : data
  if (!row) return null
  return mapAccessState(row)
}

export async function dismissAccountPlanOverrideNotice(): Promise<void> {
  const { error } = await supabase.rpc('dismiss_account_plan_override_notice')
  if (error) throw error
}

export async function ensureFreemiumAccess(): Promise<{ ok?: boolean; action?: string } | null> {
  try {
    const { data, error } = await supabase.functions.invoke('ensure-freemium-access', { body: {} as any })
    if (error) throw error
    return (Array.isArray(data) ? (data as any)[0] : (data as any)) || null
  } catch {
    return null
  }
}
